import { render, staticRenderFns } from "./DownTimeTrend.vue?vue&type=template&id=66c80566&scoped=true"
import script from "./DownTimeTrend.vue?vue&type=script&lang=js"
export * from "./DownTimeTrend.vue?vue&type=script&lang=js"
import style0 from "./DownTimeTrend.vue?vue&type=style&index=0&id=66c80566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c80566",
  null
  
)

export default component.exports